const supportedTags = {
  '24v': { tooltip: 'Applicable for both communicating and 24v non-communicating equipment' }
}

export default supportedTags
